module.exports = __webpack_public_path__ + "static/media/celo.6e8b0fb4.svg";